import { AlertVariant } from "@walmart-web/livingdesign-components"
import { SELLOUT_REPORT, SELLOUT_REPORT_SUBMODULE } from "constants/paths"
import { HeaderTableColumn } from "./Table"

export const TABLE_HEADER: HeaderTableColumn[] = [
	{
		key: "header.date",
		title:
			"phronesis.sellout_report.application.reporting_sellout.table.header.date",
		alignment: "left",
		width: "80%",
	},
	{
		key: "header.reportType",
		title:
			"phronesis.sellout_report.application.reporting_sellout.table.header.reportType",
		alignment: "left",
		width: "20%",
	},
]

export const TITLE_TABLE_TRANSLATION_ID =
	"phronesis.sellout_report.application.reporting_sellout.table.header"

export const NO_RESULT_MESSAGE = {
	name:
		"phronesis.sellout_report.application.reporting_sellout.message.nodata.title",
	message: "",
}

export const BREADCRUMB_OPTIONS = [
	{
		id: "phronesis.sellout_report.application.sellout_report",
		path: SELLOUT_REPORT,
	},
	{
		id: "phronesis.sellout_report.application.reporting_sellout",
		path: SELLOUT_REPORT_SUBMODULE,
	},
]

export const MESSAGE_HINT = {
	id: "phronesis.sellout_report.application.reporting_sellout.hint",
	type: "info" as AlertVariant,
}
